(function(){

    var $el       = $( "#instafeed" );
    var $loadMore = $(".js-instafeed-load");

    var PRODUCT_KEYWORD = "https://ashabyadm.com";

    var config = {
        get: "user",
        limit: 20,
        resolution: "standard_resolution",
        accessToken: "23658109.1677ed0.b9b42d47dca84aa5b1efd40168cc46cf",
        userId: 23658109,
        clientId: "bfac4b94f70243fc9174e0dc31fa123f",
        template: '<div data-caption="{{caption}}" class="instafeed-item"><img src="{{image}}" alt="" class="instafeed-item__image"><div class="instafeed-item__caption"><a href="{{caption}}" class="btn">Explore The Collections</a></div></div>',
        mock: true,
        success: function(json){

            var self = this;
            var template = self.options.template;
            var items = [], urls;

            $.each(json.data, function(index, obj){

                if(obj.caption){
                    urls = getProductsUrls(obj.caption.text);
                }

                // Get {{ caption }} in regex globally.
                var regexCaption = new RegExp("\{\{caption\}\}", "g");

                var itemTemplate = template
                .replace("{{link}}", obj.link)
                .replace("{{image}}", obj.images[self.options.resolution].url)
                .replace(regexCaption, urls.length ? urls[0] : "null");

                // Populate variables and push each item to an array of items.
                items.push( $(itemTemplate) );

            });

            // Append to the DOM.
            $el.append(items);

        },
        after: function(){

            // disable button if no more results to load.
            if ( !this.hasNext() ) {
                $loadMore.remove();
            }

        }
    };

    var getProductsUrls = function(str){

        var words, matches = [];

        // Format.
        str   = formatWords(str);
        words = str.split(" ");

        $.each(words, function(index, word){

            if( isProductUrl(word) ){
                matches.push(word);
            }

        });

        if(matches.length){
            console.log(matches);
        }

        return matches;

    };

    var formatWords = function(str){
        // Remove whitespace chars.
        return str.replace(/\r?\n|\r/g, "").toLowerCase();
    };

    var isProductUrl = function(str){
        return str.indexOf(PRODUCT_KEYWORD) !== -1;
    };

    if ( $el.length ) {

        var feed = new Instafeed(config);

        $loadMore.on('click', function(){
            feed.next();
        });

        feed.run();
    }

})();
